import React from "react"
import Icon from "./Icon"
import BackArrow from "../assets/back_arrow.svg"

const BackIcon = props => <Icon src={BackArrow} square {...props} />

export default BackIcon
